
import React from "react";
import { useState, useEffect } from 'react';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpotLoc, getSpotsList } from "../../../../../../store/selectors.js";

//created components
import SelectLieu from '../../../../../../steps/step1/components/selectlieu/SelectLieu.jsx'
import PeriodPicker from '../../components/periodpicker/PeriodPicker.jsx'
import ButtonValidStep1 from '../../../../../../steps/step1/components/buttonValid/ButtonValidStep1.jsx'
import DisplayDuree from '../../../../../../steps/step1/components/displayduree/DisplayDuree.jsx'
import HeaderStep from "../../../../../../commons/headerstep/HeaderStep.jsx";
import AdresseLivraison from "../../components/adresselivraison/AdresseLivraison.jsx";




//import google map component
import GMap from "../../../../../../components/gmap/GMap.jsx";
import { Navigate, useNavigate } from "react-router-dom";



/* let listSpots = [];
axios.get(baseURL + "/spot").then((response) => {
    listSpots = [].concat(response.data);

}); */


function StepOne() { // component to manage the first step of shopping : choosing place and time
    const dispatch = useDispatch();
    const navigate = useNavigate();



    const idSpotLoc = useSelector(getIdSpotLoc); //global state : id of the selected spot
    const listSpots = useSelector(getSpotsList); //global state : id of the selected spot
    let infosSpot = "";
    let nomSpot = "";
    let myCenter = {}; //center of the google map (set dynamically by selected spot)



    /*  useEffect(() => { //change opening hours when spot change (idspot as dependency)
         console.log(listSpots);
         console.log(idSpotLoc);
 
 
     }, [listSpots, idSpotLoc]) */

    console.log(idSpotLoc)
    if (idSpotLoc > 0) { //prepare spot informations
        let currentSpot = listSpots.filter((spot) => spot.id_spot === idSpotLoc);
        //if (!currentSpot[0]) { navigate('../manager/'); console.log("chute bete") }
        nomSpot += currentSpot[0].nom_spot;
        infosSpot += currentSpot[0].nom_spot;
        infosSpot += " - " + currentSpot[0].adresse_spot;
        infosSpot += " " + currentSpot[0].cp_spot;
        infosSpot += " " + currentSpot[0].ville_spot;

        myCenter = { //set google map center
            lat: +currentSpot[0].gps_lat,
            lng: +currentSpot[0].gps_long
        };

    }




    return (
        <div>
            {/* custumizable header component : */}
            <HeaderStep step={1} title={"Lieu / Durée de location"} custom={""} />


            {/*  "main" Div */}
            <div className="step1">

                <div className="step1-lieu-periode">

                    <div className="step1-lieu">
                        <h2>{nomSpot}</h2>
                        <p>{infosSpot}</p> {/* spot infos */}
                        {idSpotLoc > 0 && idSpotLoc < 99 ? <GMap focus={myCenter} className="map-google" /> : null} {/* show map when a spot is selected */}
                        {idSpotLoc === 99 ? <AdresseLivraison /> : null /* display form and alert for livraison */}
                    </div>

                    <div className="step1-periode">
                        <PeriodPicker activate={(idSpotLoc > 0)} managerMode={true} /> {/*  datepicker disbled if no spot selected */}

                        <DisplayDuree />

                    </div>

                </div>
                <div>
                    <ButtonValidStep1 idSpot={idSpotLoc === 99 ? 0 : idSpotLoc} />
                </div>



            </div>

        </div>
    )
}




export default StepOne